
// Add +/1 To QTY Inputs
export default function buttoned() {
    $("div.buttoned").each(function () {
        if (!($(this).hasClass('hadButton'))) {
            $(this).addClass('hadButton');
            if (!($(this).hasClass('noprepend'))) {
               $(this).prepend('<a data-delta="-1" class="c-pointer dec qty-button changeToCart">-</a>');
                $(this).append('<a data-delta="1" class="c-pointer inc qty-button changeToCart">+</a>');
            }
            //
            $(this).find(".qty-button").each(function () {
                $(this).on("click", function() {
                    var $button = $(this);
                    var oldValue = $button.parent().find("input").val();

                    if ($button.text() == "+") {
                    var newVal = parseFloat(oldValue) + 1;
                    } else {
                        // Don't allow decrementing below one
                        if (oldValue > 1) {
                            var newVal = parseFloat(oldValue) - 1;
                        } else {
                            newVal = 1;
                        }
                    }
                    $button.parent().find("input").val(newVal);

                });
            });
        }
    });
}

(function() {
    'use strict';
    window.addEventListener('load', function() {
        buttoned();
    }, false);
})();

